import { memo, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { Deposit } from '@/components/atoms/assets/Deposit'
import { Button } from '@/components/atoms/Button'
import {
  DepositCurrency,
  DepositCurrencyRef,
} from '@/components/organisms/DepositCurrency'

const DepositButtonComponent = () => {
  const { t } = useTranslation('common')
  const depositCurrencyRef = useRef<DepositCurrencyRef>()

  return (
    <>
      <Button
        onClick={() => depositCurrencyRef.current.openModal()}
        fill="outline"
      >
        <Deposit className="h-3 xs:h-4 mr-1" />
        <span className="text-xxs xs:text-xs">{t('wallet.deposit')}</span>
      </Button>
      <DepositCurrency
        title={t('depositBottomSheet.receive')}
        ref={depositCurrencyRef}
      />
    </>
  )
}

export const DepositButton = memo(DepositButtonComponent)
